import ObjArrUtils from '@/utils/ObjArrUtils'
import CookieUtils from '@/utils/CookieUtils'
import i18n from '@/plugins/i18n'
import { Base, error } from '@/store/base/module'
import { useUpdateLocale } from '@/utils/i18nUtils'

const initApis = {
  menu:{
    api: 'T0012AuthorityService.getMenu',
  },
  m0110Center :{
    api: 'M0110CenterService.getCentersDropdown_ShortLabel',
    input: {
      group_flag: 0
    }
  },
  m0110CenterGroup :{
    api: 'M0110CenterService.getCentersDropdown_ShortLabel',
    input: {
      group_flag: 1
    }
  },
  m0110Center_Authority :{
    api: 'M0110CenterService.getCentersDropdown_ShortLabel_Authority',
    input: {
      group_flag: 0
    }
  },
  m0110CenterGroup_Authority :{
    api: 'M0110CenterService.getCentersDropdown_ShortLabel_Authority',
    input: {
      group_flag: 1
    }
  },
  C11101MeetingChecklist :{
    api: 'M0020NamesService.C11101_getMeetingChecklist',
    input: {}
  },
  getFrontendLang: {
    api: 'AuthService.getFrontendLang',
    input: {}
  },
  authM0040:{
    api: 'AuthService.authM0040',
  },
  ENV_getConfigs: {
    api: 'AuthService.ENV_getConfigs',
    input: [
      'app.C11101_CHATROOM_CHECK_INTERVAL',
      'app.C11101_GET_JOINED_STUDENT_INTERVAL'
    ]
  },
}

function initCommits(commit, data) {
  if (data.menu.output) {
    commit('SET_MENU', data.menu.output)
  }
  $this.$setState('Auth', {
    m0110Center: data.m0110Center.output,
    m0110CenterGroup: data.m0110CenterGroup.output,
    m0110Center_Authority: data.m0110Center_Authority.output,
    m0110CenterGroup_Authority: data.m0110CenterGroup_Authority.output,
    C11101MeetingChecklist: data.C11101MeetingChecklist.output,
    authM0040: data.authM0040.output,
    ENV_getConfigs: data.ENV_getConfigs.output,
  })

  // i18n
  const frontendLang = data.getFrontendLang.output
  commit('setState',{
    availableLocales: frontendLang.availableLocales
  })
  CookieUtils.setCookie('locale', frontendLang.locale)
  i18n.global.locale.value = frontendLang.locale
  i18n.global.messages.value[frontendLang.locale] = { ...frontendLang.data }

  useUpdateLocale(frontendLang.locale)
}
/**
 * @type {import('vuex').Module}
 */
const module = {
  state: {
    init: null,
    logged: !!localStorage.getItem('logged'),
    user: {},

    // Locale
    availableLocales: [],

    menu:[],
    m0110Center: [],
    m0110CenterGroup: [],
    m0110Center_Authority: [],
    m0110CenterGroup_Authority: [],
    C11101MeetingChecklist: [],

    // $this.$store.state.Auth.authM0040
    authM0040:[], // http://localhost:8000/data.api?api=AuthService.authM0040

    ENV_getConfigs: {
      'app.C11101_CHATROOM_CHECK_INTERVAL':60,
      'app.C11101_GET_JOINED_STUDENT_INTERVAL':60,
    },
  },
  getters: {
    getInit(state) {
      return state.init
    },

    getLogged(state) {
      return state.logged
    },

    getUser(state) {
      return state.user
    },

    // ! deprecated
    getUserRole(state) {
      return state.user.role_code ?? null
    },

    // ! deprecated
    getUserPermissions(state) {
      return state.user.permissions ?? null
    },
    getUserAuthorityFunctionIDs(state) {
      return state.user.authority_function_ids ?? []
    },
    getAdditionalAuthorityFunctionIDs(state, getters) {
      const globalIncludedIDs = ['Chatroom', 'PendingSchedule', 'MeetingLog', 'C50103']
      if (getters.isAdmin) return [...globalIncludedIDs,'C50102','M20201']
      if (getters.isTeacher) return [...globalIncludedIDs,'C50102', 'C20201','C10101Edit']
      if (!state.user) return [...globalIncludedIDs,]
      if (state.user.user_type_code === 110) return [...globalIncludedIDs,'C50102', 'C30101','C40501']
      if (state.user.user_type_code === 120) return [...globalIncludedIDs,'C50102']
      if (state.user.user_type_code === 130) return [...globalIncludedIDs,'C50102']
      return []
    },
    getExcludedAuthorityFunctionIDs(state, getters) {
      if (getters.isAdmin) return []
      if (getters.isTeacher) return ['C00101']
      if (getters.isStudent) return []
      return []
    },
    getFilteredAuthorityFunctionIDs(state, getters) {
      return [...new Set([
        ...getters.getAdditionalAuthorityFunctionIDs,
        ...getters.getUserAuthorityFunctionIDs
      ])].filter((id) => !getters.getExcludedAuthorityFunctionIDs.includes(id))
    },
    getUserDisabledRouteNames(state, getters) {
      if (state.user.user_type_code === 410) return ['C20201']
      if (state.user.user_type_code === 420) return ['C20101', 'C20201']
      if (state.user.user_type_code === 430) return ['C20101', 'C20201']
      return []
    },
    getMeetingPlatform(state) {
      return state.user.meeting_platform
    },
    isSuperAdmin(state) {
      // Check backend UserUtils.setUser for logic
      return state.user && state.user.isSuperAdmin
    },
    /**
     * isAdmin is wrong, 410,420,430 are not admin, they are classroom
     * so use `isClassroom` or `isAdmin2` instead
     * @deprecated
     */
    isAdmin(state) {
      // Check backend UserUtils.setUser for logic
      return state.user && state.user.isAdmin
    },
    isAdmin2(state) {
      // Check backend UserUtils.setUser for logic
      return state.user && state.user.isAdmin2
    },
    isClassroom(state) {
      // Check backend UserUtils.setUser for logic
      return state.user && state.user.isClassroom
    },
    isTeacher(state) {
      // Check backend UserUtils.setUser for logic
      return state.user && state.user.isTeacher
    },
    isStudent(state) {
      // Check backend UserUtils.setUser for logic
      return state.user && state.user.isStudent
    },
    Auth_authorizeUserTypes: (state) => (userTypeCodes=[]) => {
      if (!state.user) return false
      if (!Array.isArray(userTypeCodes)) userTypeCodes = [userTypeCodes]
      return userTypeCodes.includes(state.user.user_type_code)
    },
    // $this.$store.getters['Auth/Auth_getTimeLimitNameMap']
    Auth_getTimeLimitNameMap (state) {
      let output = {}
      state.authM0040?.forEach(t => {
        output[t.time_limit_no] = t.time_limit_name
      })
      return output
    },
    // $this.$store.getters['Auth/Auth_getTimeLimitGroupNameMap']
    Auth_getTimeLimitGroupNameMap (state) {
      let output = {}
      state.authM0040?.forEach(t => {
        const groupNo = Math.floor(t.time_limit_no / 10) * 10
        output[t.time_limit_no] = state.authM0040?.find(t => t.time_limit_no === groupNo)?.time_limit_name || ''
      })
      return output
    },
    // $this.$store.getters['Auth/Auth_getTimeLimit_without0']
    Auth_getTimeLimit_without0(state){
      return state.authM0040?.filter(t => t.time_limit_no % 10 !== 0) || []
    },
    // $this.$store.getters['Auth/Auth_getTimeLimit_with0']
    Auth_getTimeLimit_with0(state){
      return state.authM0040?.filter(t => t.time_division === 0) || []
    },
    // $this.$store.getters['Auth/Auth_timeLimitGroupOptions']
    Auth_timeLimitGroupOptions(state){
      return state.authM0040?.filter(t => t.time_division === 0)?.map(t => ({
        text: t.time_limit_name,
        value: t.time_limit_no/10,
      })) || []
    },
  },

  mutations: {
    INIT(state) { // Add commit to the arguments if needed, or access via this.commit
      if (state.logged && ObjArrUtils.isEmpty(state.user)) {
        this.commit('Auth/SET_LOGGED', false) // Use mutation
        this.commit('Notification/SET_NOTIFY_WARNING', {
          text: window.vue.$i18n.t('auth.sessionTimeout')
        })
      }
      state.init = true
    },
    SET_LOGGED(state, value) {
      state.logged = value
      if (value) {
        localStorage.setItem('logged', '1')
      } else {
        localStorage.removeItem('logged')
      }
    },
    SET_MENU(state, value) {
      state.menu = value
    },
    CLEAR_USER(state) {
      window.vue.config.globalProperties.$resetState()
      state.user = {}
      state.logged = false
      state.init = null
      localStorage.removeItem('logged')
      localStorage.removeItem('init')
    },
  },
  actions: {
    async Auth_resetCache ({ commit }) {
      return $this.$api.postData({
        data:
        { ...initApis }
      }).then((data) => {
        initCommits(commit, data)
      })
    },
    async Auth_login ({ commit, state }, authInfo)  {
      return $this.$api.postData({
        data:
        {
          user: { api: 'AuthService.Auth_login', input: authInfo },
          ...initApis
        }
      })
        .then((data) => {
          if (data.user.output) {
            state.user = data.user.output
            commit('SET_LOGGED', true) // Use mutation
            initCommits(commit, data)
          }
          localStorage.removeItem('init')
          return data.user.output
        })
    },
    async Auth_register ({ state, commit }, authInfo)  {
      return $this.$api.postData({
        data:
        {
          user: { api: 'AuthService.Auth_register', input: authInfo },
          ...initApis
        }
      })
        .then((data) => {
          if (data.user.output) {
            state.user = data.user.output
            commit('SET_LOGGED', true) // Use mutation
            initCommits(commit, data)
          }
          localStorage.removeItem('init')
          return data.user.output
        })
    },
    async Auth_logout ({ state, commit }, { notifyMessage = window.vue.$i18n.t('auth.logout.success') } = {})  { // Add commit
      return $this.$api.auth({ data: { auth: { api: 'AuthService.Auth_logout' } } })
        .then((data) => {
          localStorage.removeItem('init')
          localStorage.removeItem('X-Session-Id')
          window.vue.config.globalProperties.$resetState()
          state.user = {}
          commit('SET_LOGGED', false) // Use mutation
          if(notifyMessage) window.vue.$dialog.notify.info(notifyMessage)
          window.vue.$router.replace({
            name: 'Login',
            // query: {
            //   next: window.vue.$router.currentRoute.fullPath
            // }
          })
        })
    },
    async Auth_init  ({ commit, state }, word)  {
      state.init = true
      const data = await $this.$api.auth({
        data:
        {
          user: { api: 'AuthService.Auth_getCurrentUser' },
          ...initApis
        }
      }).catch((error) => {
        state.init = false
        throw error
      })
      try {
        if (typeof data !== 'object')
          throw new Error('init data is not object')

        if (data.user.output) {
          state.user = data.user.output
          commit('SET_LOGGED', true) // Use mutation
          initCommits(commit, data)
        }
        return data?.user.output
      } catch (error) {
        console.error('Auth_init error', error)
        // refresh page
        window.location.reload()
      }
    },
    setUserLocale: ({ commit, state }, input) => {
      return $this.$api.auth({ data: { auth: { api: 'AuthService.setUserLocale', input } } })
        .then((data) => {
          return data.auth.output
        })
    },
    async M20901_ResetPassword({  dispatch }, payload) {

      const result = await $this.$api.postData({
        data: [
          {
            api: 'T0010UsersService.M20901_ResetPassword',
            input: payload
          }
        ]
      })

      dispatch('Auth_init')

      return result[0].output
    },
  }
}

export default ObjArrUtils.merge(Base, error, module)
